<template>
  <div class="row">
    <div class="col-auto time-period-col">
      <div class="filter-control-group">
        <Select
          :model-value="selectedFilter"
          @update:model-value="handleFilterChange"
          :options="timePeriodOptions"
          label="TIME PERIOD"
          placeholder="Select period"
          size="sm"
          class="time-period-select"
        />
      </div>
    </div>
    <div class="col-auto" style="padding-left: 0px">
      <div class="filter-control-group">
        <label class="filter-label">DATE RANGE</label>
        <Datepicker
          :model-value="dateRange"
          @update:model-value="handleDateRangeChange"
          range
          :enable-time-picker="false"
          placeholder="Select Date"
          input-class="date-filter-input"
          format="MMM dd, yyyy"
          :auto-apply="true"
          teleport
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Select } from "@/components/ui";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

defineOptions({
  name: "DateFilterControls",
});

const props = defineProps({
  dateRange: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(["filterByDate", "update:dateRange"]);

// Refs
const selectedFilter = ref("thisWeek");

// Constants
const timePeriodOptions = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "thisWeek", label: "This Week" },
  { value: "pastWeek", label: "Past Week" },
  { value: "thisMonth", label: "This Month" },
  { value: "pastMonth", label: "Past Month" },
  { value: "thisQuarter", label: "This Quarter" },
  { value: "pastQuarter", label: "Past Quarter" },
  { value: "thisYear", label: "This Year" },
  { value: "pastYear", label: "Past Year" },
  { value: "custom", label: "Custom Range" },
];

// Methods
const handleFilterChange = (filter) => {
  selectedFilter.value = filter;
  emit("filterByDate", filter);
};

const handleDateRangeChange = (value) => {
  selectedFilter.value = "custom";
  emit("update:dateRange", value);
};
</script>

<style scoped>
.filter-control-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.filter-label {
  font-size: 10px;
  font-weight: 400;
  color: #344054;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

::v-deep(.date-filter-input) {
  height: 43px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background-color: #ffffff;
  color: #282a30;
  font-size: 0.82rem;
  font-weight: 400;
  font-family: "Inter", sans-serif !important;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
  width: 100%;
}

::v-deep(.date-filter-input::placeholder) {
  color: #9ca3af;
  opacity: 1;
  font-family: "Inter", sans-serif !important;
}

::v-deep(.date-filter-input:hover) {
  border-color: #9ca3af;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
}

::v-deep(.date-filter-input:focus) {
  outline: none;
  border-color: #3e3efe;
  box-shadow:
    0 0 0 3px rgba(62, 62, 254, 0.1),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
}

.filter-control-group :deep(.ui-select__label) {
  font-size: 10px;
  font-weight: 400;
  color: #344054;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.time-period-col {
  min-width: 200px;
}

.time-period-select :deep(.ui-select__field) {
  height: 36px;
  padding: 8px 36px 8px 12px;
  min-width: 200px;
}
</style>
